import { IApplicationState } from '../../types/redux';
import { getFilters } from './getFilters';

export function getReadyApartments(state: IApplicationState) {
  const filters = getFilters(state);

  return filters.readyApartments;
}
